export default __webpack_public_path__ + "static/media/IMG_4580-min.2bb14438.JPG";